import { render, staticRenderFns } from "./EntriesCards.vue?vue&type=template&id=61368614"
import script from "./EntriesCards.vue?vue&type=script&lang=js"
export * from "./EntriesCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports